module.exports = __webpack_public_path__ + "static/media/loop.6460eb9b.png";